var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-table-wrapper overflow-auto"},[_c('div',{staticClass:"main-table"},[_c('pulse-loader',{attrs:{"loading":_vm.loading,"color":_vm.constants.spinnerColor}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }